import React from 'react'
import '../styles/footer.css';
import riLogo from '../assets/riLogo.png';

function Footer() {
  return (
    <div className="footerDiv">
      <img src={riLogo} className="riLogoImg" alt="rilogo" />
    </div>
  )
}

export default Footer;